function Loder() {
  return (
    <div className="h-screen flex justify-center items-center gap-2">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="h-5 w-5 bg-gray-900 animate-bounce"
          style={{
            animationDelay: `${i * 0.15}s`,
          }}
        ></div>
      ))}
    </div>
  );
}
export default Loder;
